module.exports = __webpack_public_path__ + "img/library.b619a7b3.svg";